export default "__VITE_ASSET__CvUV8uxm__"